import { create } from 'zustand';

interface GuidesListingStore {
  search: string;
}

export const GuidesFilterDefaultState = {
  search: '',
};

const useGuidesListingStore = create<GuidesListingStore>(() => GuidesFilterDefaultState);

const updateSearch = (search: string) => ({ search });

export const setGuidesSearch = (search: string) => useGuidesListingStore.setState(() => updateSearch(search));

export const clearGuidesFilters = () => useGuidesListingStore.setState(() => GuidesFilterDefaultState);

export default useGuidesListingStore;
